export const frameworks = [
  { id: 'f1', name: 'SOC 2 Type II', progress: 78, status: 'On Track', due: '2024-11-15', description: 'Trust Services Criteria for Security, Availability, and Confidentiality.' },
  { id: 'f2', name: 'ISO 27001', progress: 45, status: 'At Risk', due: '2024-12-01', description: 'International standard for information security management systems.' },
  { id: 'f3', name: 'GDPR Core', progress: 92, status: 'Reviewing', due: '2024-10-30', description: 'General Data Protection Regulation compliance for EU data.' },
  { id: 'f4', name: 'HIPAA Security', progress: 15, status: 'Planning', due: '2025-02-15', description: 'Health Insurance Portability and Accountability Act safeguard standards.' }
];

export const recentActivity = [
  { id: 1, user: 'Sarah J.', action: 'Uploaded evidence', target: 'Q3_Access_Logs.csv', time: '10m ago', type: 'success' },
  { id: 2, user: 'Mike T.', action: 'Approved policy', target: 'Data Retention v2.1', time: '1h ago', type: 'info' },
  { id: 3, user: 'System', action: 'Flagged gap in', target: 'Vendor Risk Assessment', time: '3h ago', type: 'warning' },
  { id: 4, user: 'Elena R.', action: 'Completed task', target: 'Annual Security Training', time: '5h ago', type: 'success' }
];

export const checklistData = [
  { id: 't1', framework: 'SOC 2', control: 'CC1.1', title: 'Code of Conduct Review', status: 'Compliant', owner: 'Legal Team', notes: 'Annual review completed on Oct 1st.' },
  { id: 't2', framework: 'SOC 2', control: 'CC2.1', title: 'System Access Audit', status: 'In Progress', owner: 'IT Dept', notes: 'Waiting for AWS IAM export.' },
  { id: 't3', framework: 'ISO 27001', control: 'A.9.2', title: 'User Registration Process', status: 'To Do', owner: 'HR Dept', notes: 'Needs alignment with onboarding policy.' },
  { id: 't4', framework: 'GDPR', control: 'Art. 30', title: 'Record of Processing Activities', status: 'In Review', owner: 'DPO', notes: 'Draft submitted by marketing team.' },
  { id: 't5', framework: 'SOC 2', control: 'CC6.1', title: 'Logical Access Security', status: 'Gap Identified', owner: 'SecOps', notes: 'MFA not enforced on legacy staging server.' }
];

export const evidenceVault = [
  { id: 'e1', name: 'Q3_Access_Logs.csv', type: 'CSV', size: '2.4 MB', uploadedBy: 'IT Dept', date: 'Oct 24', status: 'Verified' },
  { id: 'e2', name: 'Pen_Test_Report_2024.pdf', type: 'PDF', size: '15 MB', uploadedBy: 'SecOps', date: 'Oct 22', status: 'Pending Review' },
  { id: 'e3', name: 'Employee_Handbook_v4.pdf', type: 'PDF', size: '4.1 MB', uploadedBy: 'HR Dept', date: 'Oct 15', status: 'Verified' },
  { id: 'e4', name: 'AWS_Config_Snapshot.json', type: 'JSON', size: '890 KB', uploadedBy: 'DevOps', date: 'Oct 26', status: 'Rejected' }
];

export const faqs = [
  {
    q: "Is this a legal service?",
    a: "No. ComplianceCloud is an organizational tool designed to help teams manage their own compliance workflows, evidence, and checklists. It does not provide legal advice or guarantee regulatory approval."
  },
  {
    q: "How does the evidence linking work?",
    a: "You can upload files to the Evidence Vault and link them directly to specific framework controls. This creates a clear audit trail for internal or external reviewers."
  },
  {
    q: "Can I manage multiple frameworks simultaneously?",
    a: "Yes. Our 'Lanes' view allows you to filter by specific frameworks like SOC 2, ISO 27001, or GDPR, or view your global compliance posture across the entire organization."
  },
  {
    q: "What happens when a 'Gap' is identified?",
    a: "When a control fails to meet requirements, it is moved to the 'Gap Identified' lane. You can then assign owners, set remediation dates, and track notes until the gap is closed."
  },
  {
    q: "Is my data encrypted?",
    a: "In a production environment, all evidence and policy data are encrypted at rest (AES-256) and in transit (TLS 1.2+). This demo uses simulated storage."
  }
];